import { AuthoringHomeTitle, AuthoringHomeTile } from "./authoring-home-slot-definitions"
import { AuthoringHomeTitlePlugin } from "./plugins/authoring-home-title-plugin"
import { AuthoringHomeWorkPackagesTile } from "./plugins/authoring-home-work-packages-tile"
import { AuthoringHomeMacrosTile } from "./plugins/authoring-home-macros-tile"
import { AuthoringHomeComponentsTile } from "./plugins/authoring-home-components-tile"
import { AuthoringHomeArchivedWorkPackages } from "./plugins/archived-work-packages/authoring-home-archived-work-packages"

AuthoringHomeTitle.plug(<AuthoringHomeTitlePlugin $lazy priority={10} />)

AuthoringHomeTile.plug(<AuthoringHomeWorkPackagesTile $lazy priority={10} />)
AuthoringHomeTile.plug(<AuthoringHomeMacrosTile $lazy priority={20} />)
AuthoringHomeTile.plug(<AuthoringHomeComponentsTile $lazy priority={30} />)
AuthoringHomeTile.plug(<AuthoringHomeArchivedWorkPackages $lazy priority={40} />)
